import VueSimpleSuggest from 'vue-simple-suggest'
import Vue from "vue";


Vue.component(VueSimpleSuggest.name, VueSimpleSuggest)
